import { Companion_getInstanceg4mecbw0mfx8 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.l3z_1 = operation;
        this.m3z_1 = null;
        this.n3z_1 = Companion_getInstance().c40_1;
        this.o3z_1 = null;
        this.p3z_1 = null;
        this.q3z_1 = null;
        this.r3z_1 = null;
        this.s3z_1 = null;
        this.t3z_1 = null;
        this.u3z_1 = null;
        this.v3z_1 = null;
        this.w3z_1 = null;
        this.x3z_1 = null;
        this.y3z_1 = null;
        this.z3z_1 = true;
        this.a40_1 = null;
        this.b40_1 = null;
      }
      d40(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.m3z_1 = requestUuid;
        return this;
      }
      e40(executionContext) {
        // Inline function 'kotlin.apply' call
        this.n3z_1 = executionContext;
        return this;
      }
      f40(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.w3z_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      g40(url) {
        // Inline function 'kotlin.apply' call
        this.o3z_1 = url;
        return this;
      }
      h40(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.p3z_1 = httpMethod;
        return this;
      }
      i40(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.q3z_1 = httpHeaders;
        return this;
      }
      j40(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.q3z_1;
        tmp.q3z_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      k40(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.s3z_1 = sendApqExtensions;
        return this;
      }
      l40(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.t3z_1 = sendDocument;
        return this;
      }
      m40(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.r3z_1 = enableAutoPersistedQueries;
        return this;
      }
      n40(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.u3z_1 = canBeBatched;
        return this;
      }
      o40(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.v3z_1 = ignoreUnknownKeys;
        return this;
      }
      p40(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.x3z_1 = retryOnError;
        return this;
      }
      q40(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.y3z_1 = failFastIfOffline;
        return this;
      }
      r40(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.z3z_1 = sendEnhancedClientAwareness;
        return this;
      }
      s40(extensions) {
        // Inline function 'kotlin.apply' call
        this.a40_1 = extensions;
        return this;
      }
      j37() {
        var tmp1_operation = this.l3z_1;
        var tmp0_elvis_lhs = this.m3z_1;
        var tmp2_requestUuid = tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs;
        var tmp3_executionContext = this.n3z_1;
        var tmp4_httpMethod = this.p3z_1;
        var tmp5_httpHeaders = this.q3z_1;
        var tmp6_sendApqExtensions = this.s3z_1;
        var tmp7_sendDocument = this.t3z_1;
        var tmp8_enableAutoPersistedQueries = this.r3z_1;
        var tmp9_canBeBatched = this.u3z_1;
        var tmp10_ignoreApolloClientHttpHeaders = this.w3z_1;
        var tmp11_retryOnError = this.x3z_1;
        var tmp12_failFastIfOffline = this.y3z_1;
        var tmp13_ignoreUnknownKeys = this.v3z_1;
        var tmp14_sendEnhancedClientAwareness = this.z3z_1;
        var tmp15_url = this.o3z_1;
        var tmp16_extensions = this.a40_1;
        var tmp17_onError = this.b40_1;
        return new (ApolloRequest())(tmp1_operation, tmp2_requestUuid, tmp16_extensions, tmp17_onError, tmp3_executionContext, tmp15_url, tmp4_httpMethod, tmp5_httpHeaders, tmp6_sendApqExtensions, tmp7_sendDocument, tmp8_enableAutoPersistedQueries, tmp9_canBeBatched, tmp13_ignoreUnknownKeys, tmp10_ignoreApolloClientHttpHeaders, tmp11_retryOnError, tmp12_failFastIfOffline, tmp14_sendEnhancedClientAwareness);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, extensions, onError, executionContext, url, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreUnknownKeys, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.t40_1 = operation;
        this.u40_1 = requestUuid;
        this.v40_1 = extensions;
        this.w40_1 = onError;
        this.x40_1 = executionContext;
        this.y40_1 = url;
        this.z40_1 = httpMethod;
        this.a41_1 = httpHeaders;
        this.b41_1 = sendApqExtensions;
        this.c41_1 = sendDocument;
        this.d41_1 = enableAutoPersistedQueries;
        this.e41_1 = canBeBatched;
        this.f41_1 = ignoreUnknownKeys;
        this.g41_1 = ignoreApolloClientHttpHeaders;
        this.h41_1 = retryOnError;
        this.i41_1 = failFastIfOffline;
        this.j41_1 = sendEnhancedClientAwareness;
      }
      k41() {
        return this.l41(this.t40_1);
      }
      l41(operation) {
        return (new (Builder())(operation)).d40(this.u40_1).e40(this.x40_1).g40(this.y40_1).h40(this.z40_1).i40(this.a41_1).k40(this.b41_1).l40(this.c41_1).m40(this.d41_1).n40(this.e41_1).p40(this.h41_1).q40(this.i41_1).f40(this.g41_1).o40(this.f41_1).r40(this.j41_1).s40(this.v40_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
